import { types } from '../types/types'

const initialState = {
    delivery: [],
    deliveryN: [],
    deliveryE: [],
    listDOrO: []
}

export const deliveryReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.deliveryLoaded:
            return {
                ...state,
                delivery: [...action.payload]
            }

        case types.deliveryNLoaded:
            return {
                ...state,
                deliveryN: [...action.payload]
            }

        case types.deliveryExpeditionLoaded:
            return {
                ...state,
                deliveryE: [...action.payload]
            }

        case types.ordersOrDeliverysListExpLoaded:
            return {
                ...state,
                listDOrO: action.payload
            }

        case types.resetDeliveryN:
            return {
                ...state,
                deliveryN: []
            }

        default:
            return state;
    }
}

export default deliveryReducer;